module.exports = __webpack_public_path__ + "zw.11d8f0e969313c6470dd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/zw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/zw.svg
// module chunks = styles